import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table,Modal,
} from 'reactstrap';
import _ from 'lodash'
import { Field, reduxForm } from 'redux-form';
import moment from 'moment'
import './styles.css';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderSelectField from '../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import { MDBDataTable, MDBBtn, MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import axios from "axios";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import 'antd/dist/antd.css';
import { TimePicker } from 'antd';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import Rectangle from "../../../../images/rectangle.png";
import GreenTick from "../../../../images/green_tick.svg";
import RedCross from "../../../../images/red_cross.svg";
import YellowClock from "../../../../images/yellow_clock.svg";



 
import "react-datepicker/dist/react-datepicker.css";
/*import './styles.css';
*/

var url = window.location.hostname;
var port = window.location.port;
const options2 = [
  { value: 'wmsUser', label: 'wmsUser' },
  { value: 'test', label: 'wmsUser' },
];

const optionsUser = [];



class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.toggle = this.toggle.bind(this);
    this.Errortoggle = this.Errortoggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.fetchGRNData = this.fetchGRNData.bind(this);
    this.btnClick = this.btnClick.bind(this);
    this.EditToggle  = this.EditToggle.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.toggleAssignUserCycleCount = this.toggleAssignUserCycleCount.bind(this);
    this.showTypeahead = this.showTypeahead.bind(this);
    this.showTypeaheadChange = this.showTypeaheadChange.bind(this);
    this.closeContainer = this.closeContainer.bind(this);
    this.setBinId = this.setBinId.bind(this);
    this.onQuantityChange1 = this.onQuantityChange1.bind(this);
    this.changeICLDQty = this.changeICLDQty.bind(this);
    this.changeLooseQty = this.changeLooseQty.bind(this);
    this.changeTesterQty = this.changeTesterQty.bind(this);
    this.processData = this.processData.bind(this);
    this.CancelErrorToggle = this.CancelErrorToggle.bind(this);
    this.reloadData = this.reloadData.bind(this);
    this.processData1 = this.processData1.bind(this);
    this.ConfirmPutAway = this.ConfirmPutAway.bind(this);
    this.Successtoggle = this.Successtoggle.bind(this);
    this.CancelSuccessToggle = this.CancelSuccessToggle.bind(this);
    this.checkedSingle = this.checkedSingle.bind(this);
    this.Confirmtoggle = this.Confirmtoggle.bind(this);
    this.CancelConfirmToggle = this.CancelConfirmToggle.bind(this);
    this.processUpdateData = this.processUpdateData.bind(this);
    this.CancelErrorMessageToggle = this.CancelErrorMessageToggle.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.ErrorMessagetoggle = this.ErrorMessagetoggle.bind(this);
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.beforeConfirm = this.beforeConfirm.bind(this);
    this.CancelBeforeModal = this.CancelBeforeModal.bind(this);
    this.handleChangeTime = this.handleChangeTime.bind(this);
    this.StepSuccessToggle = this.StepSuccessToggle.bind(this);
    this.CancelStepSuccessToggel = this.CancelStepSuccessToggel.bind(this);
    this.pressStep1 = this.pressStep1.bind(this);
    this.pressStep2 = this.pressStep2.bind(this);
    this.pressStep3 = this.pressStep3.bind(this);
    this.pressStep4 = this.pressStep4.bind(this);
    this.recheckData = this.recheckData.bind(this);
    this.fetchUserList = this.fetchUserList.bind(this);
    this.onChangeVal = this.onChangeVal.bind(this);
    /*this.showTypeahead = this.showTypeahead.bind(this);*/
    this.state = {
      showPassword: false,
      loading: false,
      startDate: new Date(),
      schemas: [],
      showFetchGRNData: true,
      showFetchGRNDataTester: false,
       zoomLevel: 1,
      loadingupdatebtn: false,
      productData: [],
      disabledBtnConfirm: false,
      reason_needed: true,
      genloading: false,
      StepSuccessModal: false,
    StepCompleteModal: false,
      pickingHistoryId: '',
      rows: [],
      grnNumber: '',
      grnValues: '',
      selectedOptions: '',
      newArrayData1: [],
      errorMessage: '',
      changeStatus: '',
      loadingbtn: false,
      loadingbtn0: false,
      loadingbtn1: false,
      loadingbtn2: false,
      loadingbtn3: false,
      loadingbtn4: false,
      alertMessage: '',
      messageModal: false,
      ErrorMessagemodal: false,
      modalAssignUserCycleCount: false,
      postsGRN: [],
      postsProduct: [],
      tableRowsGRN: [],
      tableRowsGRNTester: [],
      ErrorRowData: [],
      options: [],
      newArrayData: [],
      selectedUser: {},
      showDateError: {},
      modal: false,
      Confirmmodal: false,
      EditModal: false,
      typeaheadText: '' ,
      pkd_val: '',
      lbskuid_val:'',
      mrp_val: '',
      quantity: '',
      defaultquantity: '',
      putawayHistoryId: '',
      showTypeahead:false,
      zwz_search_pannel: false,
      data: [],
      binId: '',
      hover_nod_data: [],
      batchData: [],
      showContainer: [],
      setBinIdLoop: {},
      splitData: [],
      Errormodal: false,
      Successmodal: false,
      reloadBtn: false,
      ErrorMessage: '',
      SuccessMessage: '',
      showICLDError: false,
      showLooseError: false,
      showTesterError: false,
      disabledBtn1: true,
      disabledBtn0: true,
      disabledBtn2: true,
      disabledBtn3: true,
      disabledBtn4: true,
    sorting: false,
      StepSuccessMessage: "Processed",
    toenableCompleteModal: false



    };
  }


  reloadData(){
      this.setState({
        reloadBtn: true
      })
      const payload = {
        location: this.state.selectedLocation,
      };
      
    API.post('/cycle_count/fetchCycleReconList/v1/', { param: payload })
     
      .then((response) =>  {


        console.log(response);
         this.setState({
                   schemas: response.data.recon_list,
                   reloadBtn: false
               });
      })
      .catch(function (error) {
        
        
    });

      this.fetchGRNData();

  }

  recheckData(){
    this.setState({ selectedUser: {}, modalAssignUserCycleCount: true, selectedOptions: '' });

    /*var newArray = this.state.postsGRN.filter(status='UNHOLD');*/
    var arrayCartData= this.state.batchData.filter(item => item.isChecked === true); 
    console.log(arrayCartData); 
    this.setState({
      modalAssignUserCycleCount: true,
      newArrayData1: arrayCartData,
    })
    console.log(this.state.newArrayData1);

  }

  pressCaptureReason = ()=>{
    window.location.href = "/cycleCount/cc_capture_reason";
  }

  pressStep0 = () => {
    this.setState({
      loadingbtn0: true,
      loadingbtn1: false,
      loadingbtn2: false,
      loadingbtn3: false,
      loadingbtn4: false
    })

    var id = []

    for(var i = 0 ; i < this.state.batchData.length ; i++){
      id.push(this.state.batchData[i].id)
    }

    const payload = {
      location: this.state.selectedLocation,
      ids: id,
      batch_id: this.state.batchData[0].batch,
      step: 0,
    };
    
    API.post('/cycle_count/confirmCycleCount/v1/', { param: payload })

    
      .then((response) =>  {
        this.fetchGRNData();
        this.setState({
          StepSuccessModal: true,
          loadingbtn0: false
        })
  
      })
      .catch(function (error) {
           
    });


    
  }

  pressStep1(){
    this.setState({
      loadingbtn0: false,
      loadingbtn1: true,
      loadingbtn2: false,
      loadingbtn3: false,
      loadingbtn4: false
    })

    var id = []

    for(var i = 0 ; i < this.state.batchData.length ; i++){
      id.push(this.state.batchData[i].id)
    }

    console.log(id)

    const payload = {
      location: this.state.selectedLocation,
      ids: id,
      batch_id: this.state.batchData[0].batch,
      step: 1,
    };
    
  API.post('/cycle_count/confirmCycleCount/v1/', { param: payload })

    
      .then((response) =>  {
        this.fetchGRNData();
        this.setState({
          StepSuccessModal: true,
          loadingbtn1: false

        })

         
      })
      .catch(function (error) {
        
        
        
        
    });


    
  }

  pressStep2(){
    this.setState({
      loadingbtn0: false,
      loadingbtn1: false,
      loadingbtn2: true,
      loadingbtn3: false,
      loadingbtn4: false
    })
    
    var id = []

    for(var i = 0 ; i < this.state.batchData.length ; i++){
      id.push(this.state.batchData[i].id)
    }

    console.log(id)

    const payload = {
      location: this.state.selectedLocation,
      ids: id,
      batch_id: this.state.batchData[0].batch,
      step: 2,
    };
    
  API.post('/cycle_count/confirmCycleCount/v1/', { param: payload })

      .then((response) =>  {
        this.fetchGRNData();
        this.setState({
          StepSuccessModal: true,
          loadingbtn2: false
          
        })

         
      })
      .catch(function (error) {
        
        
        
        
    });
  }

  pressStep3(){
    this.setState({
      loadingbtn0: false,
      loadingbtn1: false,
      loadingbtn2: false,
      loadingbtn3: true,
      loadingbtn4: false
    })
    var id = []

    for(var i = 0 ; i < this.state.batchData.length ; i++){
      id.push(this.state.batchData[i].id)
    }

    console.log(id)

    const payload = {
      location: this.state.selectedLocation,
      ids: id,
      batch_id: this.state.batchData[0].batch,
      step: 3,
    };
    
  API.post('/cycle_count/confirmCycleCount/v1/', { param: payload })

      .then((response) =>  {
        this.fetchGRNData();
        this.setState({
          StepSuccessModal: true,
          loadingbtn3: false
          
        })

         
      })
      .catch(function (error) {
        
        
        
        
    });
  }

  pressStep4(){
    this.setState({
      loadingbtn0: false,
      loadingbtn1: false,
      loadingbtn2: false,
      loadingbtn3: false,
      loadingbtn4: true
    })
    var id = []

    for(var i = 0 ; i < this.state.batchData.length ; i++){
      id.push(this.state.batchData[i].id)
    }

    console.log(id)

    const payload = {
      location: this.state.selectedLocation,
      ids: id,
      batch_id: this.state.batchData[0].batch,
      step: 4,
    };
    
  API.post('/cycle_count/confirmCycleCount/v1/', { param: payload })

      .then((response) =>  {
        this.fetchGRNData();
        this.setState({
          StepSuccessModal: true,
          loadingbtn4: false
          
        })

         
      })
      .catch(function (error) {
        
        
        
        
    });
  }

  toggleAssignUserCycleCount(){
  /*this.setState({
    messageModal: true,
  })*/
  this.setState(prevState => ({ modalAssignUserCycleCount: !prevState.modalAssignUserCycleCount }));
}

 StepSuccessToggle(){
  /*this.setState({
    messageModal: true,
  })*/
  this.setState(prevState => ({ StepSuccessModal : !prevState.StepSuccessModal }));
}

CancelStepSuccessToggel(){
  this.setState({
    StepSuccessModal: false
  })
  
  if(this.state.toenableCompleteModal == true){
  this.setState({
    StepCompleteModal : true,
  })
  }
}
CancelCompleteToggel = () => {
  this.setState({ StepCompleteModal : false })
  window.location.reload();
}


 onChangeVal = (options, id , bin_items) => {
    const { selectedUser } = this.state
    var arr = [];
    console.log(options);
    var data = [];
    for (var i = 0; i < options.length; i++) {
      data.push(options[i]["value"])
    }
    console.log(data);
    selectedUser[id] = [];
    selectedUser[id].push(data);//options.map(item => [item.valueOf,"1"])
    selectedUser[id].push(bin_items)
    this.setState({
      selectedUser
    }, e => console.log(this.state.selectedUser))
  }



  processData1(){
    this.setState({
      loadingprintbtn: true,
    })

     var arr = []
     var batch;
     

     _.map(this.state.selectedUser, (item, key) => {
      var bin_arr = [];
      var orderData  = {};
      console.log(key);
      console.log(item);
      orderData['users'] = item[0];
      /*item[1].map(( item1 , index ) => (
        console.log(item1)
        bin_arr.push(item1.bin_address.push)


      ))*/
      batch= item[1][0].batch

      console.log(batch);

      item[1].map(item1 => {
        console.log(item1.id)
        bin_arr.push(item1.id)
      })

      orderData['cycle_recon_ids'] = bin_arr;

      arr.push(orderData);

    })

     console.log(arr);
     
     const payload = {
      create: true,
      location: this.state.selectedLocation,
      req_type: "rc",
      batch_id: batch,
      cycle_data: arr
    };
    
  API.post('/cycle_count/createCycleCount/v1/', { param: payload })
     
      .then((response) =>  {

        console.log(response);
        /*if(response.data.status_code === 201){

          this.setState({
            failedMessage : response.data.reason
          })
          this.toggleAssignUserCycleCount();
          this.failedToggleCycle();

        }*/

        if(response.data.status_code === 200 && response.data.failed.length === 0){

          this.setState({
            modalAssignUserCycleCount: false,
            loadingprintbtn: false,
            Successmodal: true

          })

         

        }

        if(response.data.status_code === 200 && response.data.failed.length > 0){

          this.setState({
            failedMessage : "This file contains some errors",
            showBinTable: false,
            showZone: false,
            showFailedItemCycle : true,
            FailedItems: response.data.failed,

          })
          this.toggleAssignUserCycleCount();
          this.failedToggleCycle();

        }


         
      })
      .catch(function (error) {
        
        
        
        
    });






  }


fetchUserList(){
  const payload = {
    location: this.state.selectedLocation,
  };
  
API.post('/auth/users/getusers', { param: payload })
          
      .then((response) =>  {


        console.log(response);
         for(var i = 0; i < response.data.length; i++) {
               // <---- Move declaration inside loop
              
            var orderData  = {};
              orderData['label'] = response.data[i].userName;
              orderData['value'] = response.data[i].userId;
              
              optionsUser.push(orderData);
              
          }

         /* console.log(this.state.options);*/



         
      })
      .catch(function (error) {
        
        
    });


  }

  handleChangeDate(key, date) {
    const { newArrayData } = this.state;
    this.setState({
      newArrayData: newArrayData.map(item => ({
        ...item,
        date: item.userName === key ? moment(new Date(date).getTime()).format('MM-DD-YYYY') : (item.date || null)
      }))
    }, () => {
      console.log(this.state.newArrayData)
    })
  };

  processUpdateData(){

    if (this.state.checkicldQty < this.state.icldQty) {
      this.setState({
        showICLDError: true
      })
      return false;
    } else{

      this.setState({
        showICLDError: false
      })
      
    }

    if (this.state.checklooseQty < this.state.looseQty) {
      this.setState({
        showLooseError: true
      })
      return false;
    }else{

      this.setState({
        showLooseError: false
      })

    }

    if (this.state.checktesterQty < this.state.testerQty) {
      this.setState({
        showTesterError: true
      })
      return false;
    }else{

      this.setState({
        showTesterError: false
      })

    }
    const payload = {
      pickedIcldQty: this.state.icldQty,
      pickedLooseQty: this.state.looseQty,
      pickedTesterQty: this.state.testerQty,
      pickingHistoryId: this.state.pickingHistoryId,
      location: this.state.selectedLocation,
    };
    
  API.post('/picking/editPicking/v1/', { param: payload })

      .then((response) =>  {

        if (response.data.success === true) {
          this.setState({
            EditModal: false
          })
        }

        this.fetchGRNData();


        console.log(response);
         
      })
      .catch(function (error) {
        
        
    });


  }

  handleChangeTime(key, time) {
    const timeval = moment(new Date(time).getTime()).format('HH:mm')
    console.log(timeval);
    const { newArrayData } = this.state;
    this.setState({
      newArrayData: newArrayData.map(item => ({
        ...item,
        time: item.userName === key ? moment(new Date(time).getTime()).format('HH:mm') : (item.time || null)
      }))
    }, () => {
      console.log(this.state.newArrayData)
    })
  };

  ErrorMessagetoggle(){
    this.setState({
      ErrorMessagemodal: true,
    })
  }

  CancelErrorMessageToggle(){
    this.setState({
      ErrorMessagemodal: false,
    })
  }



  changeICLDQty(evt){
    this.setState({
      icldQty: evt.target.value
    })

    console.log(this.state.icldQty);
  }

  changeLooseQty(evt){
    this.setState({
      looseQty: evt.target.value
    })

    console.log(this.state.looseQty);
  }

  changeTesterQty(evt){
    this.setState({
      testerQty: evt.target.value
    })

    console.log(this.state.testerQty);
  }

  EditToggle(){
    this.setState({
      EditModal: true
    })
  }

  setBinId(item){
    this.setState({
      typeaheadText: item
    })

  }

  CancelConfirmToggle(){
    this.setState({
      Confirmmodal: false
    })
    window.location.reload();
  }

  onQuantityChange1(index, value){
    const { rows } = this.state
    this.setState({
      rows: rows.map((item, i) => i === index ? { ...item, qty: value } : item),
    })

  }

  ConfirmPutAway(){
    this.setState({
      loadingbtn: true,
      disabledBtn: true,
      newArrayData: this.state.newArrayData.map(item => ({
        ...item,
        error: item.time ? null : 'Please select time.'
      }))
    }, () => {
     /* this.state.newArrayData.forEach(item => {
        if(item.error){
          return
        }
      })*/

      for (var i = 0; i < this.state.newArrayData.length; i++) {
        if (this.state.newArrayData[i].error) {
          return false;
        }
      }

       /* for(var i = 0; i < this.state.newArrayData.length; i++) {
           
           if (this.state.newArrayData[i].date === null) {
            console.log("dfghdfghdfg");
            const { showDateError } = this.state;

            showDateError[i] = true

            this.setState({
              showDateError
            })
            return false;
           }   
              
           
          }*/

        var arr = [];
        for(var i = 0; i < this.state.newArrayData.length; i++) {
              
              
            var orderData  = {};
              orderData['pickingHistoryId'] = this.state.newArrayData[i].pickingHistoryId;
              orderData['location'] = this.state.selectedLocation;
              orderData['date'] = this.state.newArrayData[i].date + " " + this.state.newArrayData[i].time;
              
              
              /*orderData['remarks'] = 'dfghjk';*/

              console.log(orderData);

              
              arr.push(orderData);
          }

          this.setState({
            disabledBtnConfirm: true,
          })
          const payload = {
            arr_data: arr,
          };
          
        API.post('/picking/confirmPicking/v1/', { param: payload })
         
            .then((response) =>  {


              console.log(response);
              /*this.setState({
                  Successmodal: true,
                })*/

                

                if (response.data[0].success === false) {
                    this.setState({
                      errorMessage: response.data[0].reason,
                      ErrorMessagemodal: true,
                      loadingbtn: false,
                      modalbeforeConfirm: false
                    })
                }else{
                  this.Confirmtoggle();
                  this.setState({
                    loadingbtn: false,
                    modalbeforeConfirm: false
                  })
                }

                /*window.location.reload();*/
             /* if (response.data[0].success= true) {
                this.setState({
                  Successmodal: true,
                })

                window.location.reload();
              }*/
              
            })
            .catch(function (error) {
              
              
          }); 
      /*})*/
    })
  }

  CancelErrorToggle(){
    this.setState({
      Errormodal: false,
    })

    this.handleRemoveRow();
  }



  CancelSuccessToggle(){
    this.fetchGRNData();
    this.setState({
      Successmodal: false,
    })



  }

  onBinChange1(index, value){
    /*showTypeahead = (e) => {*/

    /*const data_val = ["B-W-R-2" , "C-D-T-3" , "C-D-T-8" , "C-D-T-8"];*/

    /*console.log(e.target.value);*/
      
    let { showContainer, rows } = this.state
    showContainer[index] = true
    this.setState({
      showContainer,
      rows: rows.map((item, i) => i === index ? { ...item, binId: value } : item),
      /*data: data_val*/
    }, () => {
      const payload = {
        location: this.state.selectedLocation,
            binAddress: value,
            putawayHistoryId: this.state.putawayHistoryId
      };
      
    API.post('/picking/getBins/v1/', { param: payload })
      
          .then((response) =>  {


            console.log(response);
            this.setState({
              data: response.data,
            })
            
          })
          .catch(function (error) {
            
            
        })
    })

    /*console.log(value);*/



  }

  setBinIdLoop(index, value){
    const { rows, showContainer } = this.state
    this.setState({
      rows: rows.map((item, i) => i === index ? { ...item, binId: value } : item),
      showContainer: showContainer.map((item, i) => false)
    })
  }


  hideTypeahead = (e) => {
    if(this.state.showTypeahead){
      if(!this.typeahead.contains(e.target)){
        this.setState({ showTypeahead: false })
      }
    }
  }


  

   handleAddRow = () => {
    this.setState((prevState, props) => {
      const row = {};
      return { rows: [...prevState.rows, row] };
    });
  };

  handleRemoveRow = () => {
    this.setState((prevState, props) => {
      return { rows: prevState.rows.slice(1) };
    });
  };

  handleRemoveRow1 = () => {
    this.setState((prevState, props) => {
      return { rows: prevState.rows.slice(6)
       };
    });
  };

  handleRemoveRow2 = () => {
    this.setState((prevState, props) => {
      return { rows: prevState.rows.slice(0)
       };
    });
  };

  showTypeaheadChange=(e) => {
    const value = e.target.value
    this.setState({
      quantity: value
    })
  }

  showTypeahead = (e) => {
    const value = e.target.value
    this.setState({
      typeaheadText: value
    }, () => {
      /*const data_val = ["B-W-R-2" , "C-D-T-3" , "C-D-T-8" , "C-D-T-8"];*/
      this.setState({
        showTypeahead: true,
        zwz_search_pannel: true,
       /* data: data_val*/
      })
      const payload = {
        location: this.state.selectedLocation,
        binAddress: value,
        putawayHistoryId: this.state.putawayHistoryId
      };
      
    API.post('/picking/getBins/v1/', { param: payload })

        .then((response) =>  {


          console.log(response);
          this.setState({
            data: response.data,
          })
          
        })
        .catch(function (error) {
          
          
      });      
    })
  }

  closeContainer(){
    this.setState({
      showTypeahead: false
    })
  }

  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  Confirmtoggle() {
    this.setState(prevState => ({ Confirmmodal: !prevState.Confirmmodal }));
  }

  Errortoggle() {
    this.setState(prevState => ({ Errormodal: !prevState.Errormodal }));
  }

  
  Successtoggle() {
    this.setState(prevState => ({ Successmodal: !prevState.Successmodal }));
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };


  togglePressCancel(){
    this.setState({
        EditModal: false,
        
    })
  }

  CancelBeforeModal(){
    this.setState({
      modalbeforeConfirm: false
    })
  }

  checkedSingle(index, prod_code, mrp){
  console.log(this.state.batchData);
  let newData = this.state.batchData;
  /*if (newData[index].isChecked === false) {
    newData[index].isChecked  =  true;
  }else if (newData[index].isChecked === true) {
    newData[index].isChecked  =  false;
  }
  
  console.log(newData);
  this.setState({
    genloading: !this.state.genloading,
    batchData: newData
  })*/

  //let newData= this.state.batchData.filter(item => item.product_code === prod_code);

  for(var i= 0; i< newData.length; i++){
    if(newData[i].product_code === prod_code && newData[i].mrp === mrp){
      if(newData[i].isChecked == false){
        newData[i].isChecked = true;
      }else{
        newData[i].isChecked = false;
      }
      
    }
  } 

  this.setState({
    genloading: !this.state.genloading,
    batchData: newData
  })




   
   

   /*let newBinData =
      this.state.binData.map(item => ({
        ...item,
        isChecked: true
      }))

      this.setState({
        binData: newBinData
      })

      console.log(this.state.binData);

    let newData = this.state.binData;
      newData[index].isChecked  =  true;
      this.setState({
        binData: newData
      })*/

      
}

  handleChange(event) {
    this.setState({value: event.target.data,
                    grnValues: event.target.value,
                    showFetchGRNData: true,
                    batch_data_val: event.target.value,


    });

    console.log(event.target.value)

   /* var batch_data;

    var batch= this.state.schemas.filter(item => {
      console.log(item.user_id);
      console.log(event.target.value);
    
      if(item.user_id == event.target.value){
        batch_data = item.batch
      }});

    console.log(batch_data);
*/
    /*var index = event.nativeEvent.target.selectedIndex;
    console.log(event.nativeEvent.target[index].text);

    var Batch = event.nativeEvent.target[index].text.toString().split(" - ")[0]

    
    console.log(event.target.value);*/
    

    /*localStorage.setItem('userId' , event.target.value);*/
     localStorage.setItem('batch' , event.target.value);

    this.fetchGRNData();
        
  }


  componentWillMount(){

      if (window.location.port == 8091 || window.location.port === ":8090") {
          port = ":8090"
        }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }
        else{
          port = ":8088"
        }

      if (url === "localhost") {
        url= "15.206.34.41" + ":8090";

      }else{
        url= window.location.hostname + port;
      }

      var cookieUsername = this.getCookie('token');
      var Location = this.getCookie('selectedLocation');
      var username = this.accessCookie("token");
      this.setState({
        userName: cookieUsername,
        selectedLocation: Location
      })

      localStorage.setItem('userName' , username);
    }



   createCookie(cookieName,cookieValue,daysToExpire)
        {
          var date = new Date();
          date.setTime(date.getTime()+(1*24*60*60*1000));
          document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
        }

  accessCookie(cookieName)
        {
          var name = cookieName + "=";
          var allCookieArray = document.cookie.split(';');
          for(var i=0; i<allCookieArray.length; i++)
          {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name)==0)
            return temp.substring(name.length,temp.length);
         }
        return "";
        } 


        getCookie(cname) {
          var name = cname + "=";
          var decodedCookie = decodeURIComponent(document.cookie);
          var ca = decodedCookie.split(';');
          for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        }




  componentDidMount() {
    this.fetchGRNData();
      this.fetchUserList();
      // Detect zoom level when component is mounted
    this.detectZoom();
    // Add event listener to track zoom level changes
    window.addEventListener('resize', this.detectZoom);
      /* axios.post('http://'+url+'/cycle_count/fetchCycleReconList/v1/' , 

      {

        
        location: this.state.selectedLocation,
      },

     {
       headers: {
            'Content-Type': 'application/json',
            'Authorization' : this.state.userName

            
          } 

     }
     

     )
      .then((response) =>  {


        console.log(response);
         this.setState({
                   schemas: response.data.recon_list
               });
      })
      .catch(function (error) {
        
        
    });*/

      /*this.fetchGRNData();*/
  }

  componentWillUnmount() {
    // Clean up event listener when component is unmounted
    window.removeEventListener('resize', this.detectZoom);
  }

  // Function to detect zoom level using devicePixelRatio
  detectZoom = () => {
    const zoom = window.devicePixelRatio || 1; // Get zoom level
    this.setState({ zoomLevel: zoom });
  };

  fetchGRNData(){

      /*var UserId = localStorage.getItem('userId');*/
      var Batch = localStorage.getItem('batch')
      this.setState({
        
        loading: true,
        postsGRN: [],
        tableRowsGRN: [],
        tableRowsGRNTester: [],
        

      })
      const payload = {
        batch: Batch , location: this.state.selectedLocation,
      };
      
    API.post('/cycle_count/fetchCycleRecon/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {
         
         console.log("CYCLE COUNT DATA - ",data);
         // if (err) throw err;

        if (data.bin_data.length > 0) {
         console.log("LEN - ",data.length);
         if(data.bin_data[0].approved === 0 || data.bin_data[0].approved === 2){
          console.log("recheck allowed");
          this.setState({
            recheckDisable: false,
            showDisabledBtn: true
          })
         }else{
          console.log("recheck not allowed");
          this.setState({
            showDisabledBtn: true,
            recheckDisable: true
          })
         }
        if (data.bin_data[0].step_allowed === 0 && data.bin_data[0].approved === 1) {
           this.setState({
            disabledBtn0: false,
            disabledBtn1: true,
            disabledBtn2: true,
            disabledBtn3: true,
            disabledBtn4: true,
            

           })
         }

          if (data.bin_data[0].step_allowed === false && data.bin_data[0].approved === 1) {
           this.setState({
            disabledBtn0: true,
            disabledBtn1: true,
            disabledBtn2: true,
            disabledBtn3: true,
            disabledBtn4: true,
            

           })
         }

         if (data.bin_data[0].step_allowed === 1 ) {
           this.setState({
            disabledBtn0: true,
            disabledBtn1: false,
            disabledBtn2: true,
            disabledBtn3: true,
            disabledBtn4: true,
            showDisabledBtn: false
           })
         }

         if (data.bin_data[0].step_allowed === 2 ) {
           this.setState({
            disabledBtn0: true,
            disabledBtn1: true,
            disabledBtn2: false,
            disabledBtn3: true,
            disabledBtn4: true,
            showDisabledBtn: false
            
           })
         }

         if (data.bin_data[0].step_allowed === 3 ) {
           this.setState({
            disabledBtn0: true,
            disabledBtn1: true,
            disabledBtn2: true,
            disabledBtn3: false,
            disabledBtn4: true,
            showDisabledBtn: false
            
           })
         }

         if (data.bin_data[0].step_allowed === 4 ) {
           this.setState({
            disabledBtn0: true,
            disabledBtn1: true,
            disabledBtn2: true,
            disabledBtn3: true,
            disabledBtn4: false,

            showDisabledBtn: false
           
           })
         }

         if (data.bin_data[0].step_allowed === 5 ) {
           this.setState({
            disabledBtn0: true,
            disabledBtn1: true,
            disabledBtn2: true,
            disabledBtn3: true,
            disabledBtn4: true,
            showDisabledBtn: false
            
           })
         }

        }else{
        this.setState({
        toenableCompleteModal: true
        
      });
      //return false;
    }

     var filteredBinData = data.bin_data.filter(item=> item.reason_needed == true);
     console.log("filteredBinData===>>>>>", filteredBinData)

         this.setState({ batchData: data})

          let newBinData =
        data.bin_data.map(item => item.checked == true ? { ...item, isChecked: true } : {...item, isChecked: false}
           
          
        )



        this.setState({
          batchData: newBinData,
          reason_needed: filteredBinData.length > 0 ? false : true,
          approved: newBinData.length > 0 ? newBinData[0].approved : "",
          productData: data.product_data
        })

       





        console.log("BATCH DATA -",this.state.batchData);
         



      })

      .then(async() => {

        if (this.state.showFetchGRNData) {

         this.setState({ tableRowsGRN:this.assemblePostsGRN(), isLoading:false, loading: false })

        } else{

          this.setState({ tableRowsGRNTester:this.assemblePostsGRNTester(), isLoading:false, loading: false })

        }

         console.log(this.state.tableRowsGRN);

      });
  }

  assemblePostsGRN= () => {

    let postsGRN =this.state.postsGRN.map((post, index) => {

      return (

        {

          /*grnNumber: post.grnNumber,

          gnrLineNumber: post.gnrLineNumber,*/

          /*putawayHistoryId: post.putawayHistoryId,*/
          /*status: post.status == 'UNHOLD' ? <MDBBtn onClick={r => this.btnClick(post.putawayHistoryId, post.status)} style={{backgroundColor: '#4ce1b6' , color: '#fff'}} color="default" rounded size="sm">Hold</MDBBtn> : <MDBBtn  style={{backgroundColor: '#de5361', color: '#fff'}} onClick={r => this.btnClick(post.putawayHistoryId, post.status)} rounded size="sm">Release</MDBBtn>,*/

          serial: index+1,

          /*grnNumber: post.grnNumber,

          gnrLineNumber: post.gnrLineNumber,*/

          /*putawayHistoryId: post.putawayHistoryId,*/
          /*status: post.status == 'UNHOLD' ? <MDBBtn onClick={r => this.btnClick(post.putawayHistoryId, post.status)} style={{backgroundColor: '#4ce1b6' , color: '#fff'}} color="default" rounded size="sm">Hold</MDBBtn> : <MDBBtn  style={{backgroundColor: '#de5361', color: '#fff'}} onClick={r => this.btnClick(post.putawayHistoryId, post.status)} rounded size="sm">Release</MDBBtn>,*/
          

          binId: post.binAddress,

          zone_name:post.zoneName,

          zone_id: post.zoneId,

          lbskuid: post.lbSkuId, 

          pickType: post.pickType, 
          mrp: post.mrp, 

          cbuCode: post.cbu_code,        

          toPickIcldQty: post.toPickIcldQty ,

          toPickLooseQty: post.toPickLooseQty ,

          toPickTesterQty: post.toPickTesterQty ,

          PickIcldQty: post.pickedIcldQty ,

          PickLooseQty: post.pickedLooseQty ,

          PickTesterQty: post.pickedTesterQty ,


          pkd: post.pkd,

          action:  <span onClick={r => this.btnClick(post.lbSkuId, post.pkd, post.mrp, post.binAddress, post.pickingHistoryId, post.toPickIcldQty, post.toPickLooseQty, post.toPickTesterQty)} style={{ cursor: 'pointer', color: '#3ea3fc'}}>Edit</span> ,

        }

      )

    });

    return postsGRN;

  }



   assemblePostsGRNTester= () => {

    let postsGRN =this.state.postsGRN.map((post, index) => {

      return (

        {

          /*grnNumber: post.grnNumber,

          gnrLineNumber: post.gnrLineNumber,*/

          /*putawayHistoryId: post.putawayHistoryId,*/
          /*status: post.status == 'UNHOLD' ? <MDBBtn onClick={r => this.btnClick(post.putawayHistoryId, post.status)} style={{backgroundColor: '#4ce1b6' , color: '#fff'}} color="default" rounded size="sm">Hold</MDBBtn> : <MDBBtn  style={{backgroundColor: '#de5361', color: '#fff'}} onClick={r => this.btnClick(post.putawayHistoryId, post.status)} rounded size="sm">Release</MDBBtn>,*/

          serial: index+1,

          /*grnNumber: post.grnNumber,

          gnrLineNumber: post.gnrLineNumber,*/

          /*putawayHistoryId: post.putawayHistoryId,*/
          /*status: post.status == 'UNHOLD' ? <MDBBtn onClick={r => this.btnClick(post.putawayHistoryId, post.status)} style={{backgroundColor: '#4ce1b6' , color: '#fff'}} color="default" rounded size="sm">Hold</MDBBtn> : <MDBBtn  style={{backgroundColor: '#de5361', color: '#fff'}} onClick={r => this.btnClick(post.putawayHistoryId, post.status)} rounded size="sm">Release</MDBBtn>,*/
          

          binId: post.binAddress,
          basepackCode: post.basePackCode,

          zone_name:post.zoneName,

          zone_id: post.zoneId,

          lbskuid: post.lbSkuId, 

          pickType: post.pickType, 
          mrp: post.mrp, 
          cbuCode: post.cbu_code,   
          partyName: post.party_name,     

          toPickIcldQty: post.toPickIcldQty ,

          toPickLooseQty: post.toPickLooseQty ,

          toPickTesterQty: post.toPickTesterQty ,

          PickIcldQty: post.pickedIcldQty ,

          PickLooseQty: post.pickedLooseQty ,

          PickTesterQty: post.pickedTesterQty ,


          pkd: post.pkd,

          action:  <span onClick={r => this.btnClick(post.lbSkuId, post.pkd, post.mrp, post.binAddress, post.pickingHistoryId, post.toPickIcldQty, post.toPickLooseQty, post.toPickTesterQty)} style={{ cursor: 'pointer', color: '#3ea3fc'}}>Edit</span> ,

        }

      )

    });

    return postsGRN;

  }


  btnClick(LBSKUID, PKD, MRP, BinAddress, PickingHistoryId, ICLDQTY, LOOSEQTY, TESTERQTY ){
    
    this.setState({
      EditModal: true,
     /* typeaheadText: binId,*/
      pickingHistoryId: PickingHistoryId,
      binId: BinAddress,
      pkd_val: PKD,
      lbskuid_val: LBSKUID,
      mrp_val: MRP,
      icldQty: ICLDQTY,
      looseQty: LOOSEQTY,
      testerQty: TESTERQTY,
      checkicldQty: ICLDQTY ,
      checklooseQty: LOOSEQTY,
      checktesterQty: TESTERQTY,
      showTesterError: false,
      showICLDError: false,
      showLooseError: false,

    })

    console.log(LBSKUID);
   console.log(this.state.lbskuid_val);



  }


  beforeConfirm() {
    this.setState({ selectedUser: {}, modalbeforeConfirm: true, newArrayData: [] });

    /*var newArray = this.state.postsGRN.filter(status='UNHOLD');*/
    var arrayCartData= this.state.postsGRN ; 
    console.log(arrayCartData); 
    this.setState({
      newArrayData: arrayCartData,
    })
    console.log(this.state.newArrayData);
  }

  viewProductWise = () =>{

  }


  processData(){

    var orderData  = {};
     

    orderData['binAddress'] = this.state.typeaheadText;
    orderData['newPutawayQty'] = this.state.quantity;
    this.state.splitData.push(orderData);

    var total_Quantity = this.state.quantity;

    for (var i = 0; i < this.state.rows.length; i++) {
      var neworderData  = {};
      neworderData['binAddress'] = this.state.rows[i].binId;
      neworderData['newPutawayQty'] = this.state.rows[i].qty;

      console.log(neworderData);

      total_Quantity = parseInt(total_Quantity) + parseInt(this.state.rows[i].qty);


      this.state.splitData.push(neworderData);
    }

    console.log(total_Quantity);

    /*if (this.state.defaultquantity < total_Quantity) {
      
      this.setState({
        ErrorMessage: 'Total quantity split exceeds the available quantity',
        Errormodal: true,
      })

      return false;
    }*/

    const payload = {
      putawayHistoryId: this.state.putawayHistoryId,
      newPutaway: this.state.splitData,
      location: this.state.selectedLocation,
    };
    
  API.post('/picking/splitPutaway/v1/', { param: payload })

      .then((response) =>  {


        console.log(response);

        if (response.data.success_response.length > 0) {
          this.setState({
            schemas: response.data,
            modal: false,
            Successmodal: true,
            ErrorMessage: "Successfully Updated",
            rows: [],
            splitData: [],

         });

          this.fetchGRNData();
        } else if(response.data.failure_response.length > 0){
          this.handleRemoveRow2();
          this.setState({
            ErrorMessage: response.data.failure_response[0].reason,
            Errormodal: true,
            /*rows: [],*/
            splitData: [],
          })
        }

        console.log(this.state.rows);
      })
      .catch(function (error) {
        
        
    });






    

    /*console.log(this.state.splitData);*/




  }

  sortingColumn = (col_name) => {
  console.log(col_name);
  if(this.state.sorting == false){
    var items = this.state.batchData.sort(function (a, b) {
      var textA = a[col_name];
      var textB = b[col_name];
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    }); 
  }else{
    var items = this.state.batchData.sort(function (a, b) {
      var textA = a[col_name];
      var textB = b[col_name];
      return textA > textB ? -1 : textA < textB ? 1 : 0;
    });
  }
  
  this.setState({
    batchData : items,
    sorting: !this.state.sorting,
  })
  console.log(this.state.batchData);
  }


  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal } = this.state;
    const { Errormodal } = this.state;
    const { Successmodal, modalAssignUserCycleCount, StepSuccessModal } = this.state;
    const {Confirmmodal} = this.state;
    const {modalbeforeConfirm} = this.state;
    const {EditModal} = this.state;
    const {ErrorMessagemodal} = this.state;
    const {newArrayData, newArrayData1 ,selectedUser,zoomLevel } = this.state;

    const uniqueZoneData = {}
    const uniqueZoneData1 = {}
    newArrayData.map(item => {
      if(!uniqueZoneData[item.userId]){
        uniqueZoneData[item.userId] = {
          zoneId: item.userId,
          zoneName: item.userName,
          date: moment(item.date, 'MM-DD-YYYY').valueOf(),
          time: moment(item.time, 'HH:mm').valueOf(),
          error: item.error,
          items: []
        }
      }
      uniqueZoneData[item.userId].items.push(item)
    })

    console.log(newArrayData1);

    newArrayData1.map(item => {
      console.log(item.zone_no)
      if(!uniqueZoneData1[item.zone_no]){
        uniqueZoneData1[item.zone_no] = {
          zoneId: item.zone_no,
          zoneName: item.zone_name,
          items: []
        }
      }
      uniqueZoneData1[item.zone_no].items.push(item)
    })

    console.log(uniqueZoneData1);

   console.log(uniqueZoneData);



    const GRNData = {

      columns: [

       /* {

          label:'GRN Number',

          field:'grnNumber',

        },

        {

          label:'GRN Line Number',

          field:'gnrLineNumber',

        },*/

        /*{

          label:'PutAway History',

          field:'putawayHistoryId',

        },*/


       
        {

          label:'S No.',

          field:'serial',
          minimal: 'sm',
          className : "kya_rakhu"

        },


        {

          label:'BIN Id',

          field:'binId',
          minimal: 'lg'

        },

        

        {

          label:'Zone Name',

          field:'zone_name',
          minimal: 'lg'

        },

        {

          label:'Zone Id',

          field:'zone_id',
          minimal: 'lg'

        },

        {

          label:'LB SKU ID',

          field:'lbskuid',
          minimal: 'lg'

        },

        {

          label:'Pick Type',

          field:'pickType',
          minimal: 'lg'

        },


        

        

        {

          label:'MRP',

          field:'mrp',
          minimal: 'lg'

        },

        {

          label:'CBU Code',

          field:'cbuCode',
          minimal: 'lg'

        },


        {

          label:'To Pick Icld Quantity (Box)',

          field:'toPickIcldQty',
          minimal: 'lg'

        },

        {

          label:'To Pick Loose Quantity (pcs)',

          field:'toPickLooseQty',
          minimal: 'lg'

        },

        {

          label:' To Pick Tester Quantity (pcs)',

          field:'toPickTesterQty',
          minimal: 'lg'

        },

        {

          label:'Picked Icld Quantity (Box)',

          field:'PickIcldQty',
          minimal: 'lg'

        },

        {

          label:'Picked Loose Quantity (pcs)',

          field:'PickLooseQty',
          minimal: 'lg'

        },

        {

          label:'Picked Tester Quantity (pcs)',

          field:'PickTesterQty',
          minimal: 'lg'

        },

        {

          label:'PKD',

          field:'pkd',
          minimal: 'lg'

        },

        

        {

          label:'Action',

          field:'action',
          minimal: 'lg'

        },





      ],

      rows:this.state.tableRowsGRN,

    }




    const GRNDataTester = {

      columns: [

       /* {

          label:'GRN Number',

          field:'grnNumber',

        },

        {

          label:'GRN Line Number',

          field:'gnrLineNumber',

        },*/

        /*{

          label:'PutAway History',

          field:'putawayHistoryId',

        },*/


       
        {

          label:'S No.',

          field:'serial',
          minimal: 'sm',
          className : "kya_rakhu"

        },


        {

          label:'BIN Id',

          field:'binId',
          minimal: 'lg'

        },

        {

          label:'BasePack Code',

          field:'basepackCode',
          minimal: 'lg'

        },

        

        {

          label:'Zone Name',

          field:'zone_name',
          minimal: 'lg'

        },

        {

          label:'Zone Id',

          field:'zone_id',
          minimal: 'lg'

        },

        {

          label:'LB SKU ID',

          field:'lbskuid',
          minimal: 'lg'

        },

        {

          label:'Pick Type',

          field:'pickType',
          minimal: 'lg'

        },


        

        

        {

          label:'MRP',

          field:'mrp',
          minimal: 'lg'

        },

        {

          label:'CBU Code',

          field:'cbuCode',
          minimal: 'lg'

        },


        {

          label:'Party Name',

          field:'partyName',
          minimal: 'lg'

        },



        {

          label:'To Pick Icld Quantity (Box)',

          field:'toPickIcldQty',
          minimal: 'lg'

        },

        {

          label:'To Pick Loose Quantity (pcs)',

          field:'toPickLooseQty',
          minimal: 'lg'

        },

        {

          label:' To Pick Tester Quantity (pcs)',

          field:'toPickTesterQty',
          minimal: 'lg'

        },

        {

          label:'Picked Icld Quantity (Box)',

          field:'PickIcldQty',
          minimal: 'lg'

        },

        {

          label:'Picked Loose Quantity (pcs)',

          field:'PickLooseQty',
          minimal: 'lg'

        },

        {

          label:'Picked Tester Quantity (pcs)',

          field:'PickTesterQty',
          minimal: 'lg'

        },

        {

          label:'PKD',

          field:'pkd',
          minimal: 'lg'

        },

        

        {

          label:'Action',

          field:'action',
          minimal: 'lg'

        },





      ],

      rows:this.state.tableRowsGRNTester,

    }

    console.log(this.state.rows)

   
    let stepFont = '13px'
    let imageMargin = "12%"
    
    if (zoomLevel >= 1.5) {
      stepFont = '10px';
       imageMargin= '1%'
    } else if (zoomLevel >= 1.25) {
       stepFont = '11px';
        imageMargin= '1%'
    } else if (zoomLevel > 1.1) {
       stepFont = '12px';
       imageMargin= '1%'
    }

    return (
      <Col xl={12}>
        <Card>
    {/*<CardBody>
            <div className="card__title">
              <h5 className="bold-text"></h5>
              
            </div>
            <form className="form form--inline" onSubmit={handleSubmit}>
              
              <div className="form__form-group col-xl-5" style={{display: 'inline-flex'}}>
                
                <span className="form__form-group-label col-xl-6" style={{display: 'inline', paddingTop: 6, paddingBottom: 6}} >Select Cycle Count Batch</span>
                

                
                <div className="form__form-group-field col-xl-6" style={{display: 'contents'}}>
                <select className="form-control" value={this.state.value} style={{fontSize: 13, width: 230}} onChange={this.handleChange}>
                  <option value="0">Select Cycle Count Batch</option>
                  { 
                    (this.state.schemas && this.state.schemas.length > 0) && this.state.schemas.map((schema) => {
                      return (<option data={schema.name} value={schema.name}> {schema.name}</option>);
                    })
                  }
                </select>
                </div>
                
                
              </div>


              <div className="form__form-group col-xl-2" style={{display: 'inline-flex'}}>
                
                <div className="form__form-group-field col-xl-6" style={{display: 'contents'}}>
                  <ButtonToolbar className="form__button-toolbar" style={{height: 30}}>
                    <button color="primary" className="btn-sm button_enable " style={{borderRadius: 5, backgroundColor:'#70bbfd', color:'#fff'}} id="button_enable" onClick={this.reloadData} >
                    {this.state.reloadBtn && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }

                      Reload
                    </button>
                </ButtonToolbar>
                 
                </div>

                
                
              </div>
            
            
            </form>
  </CardBody>*/}

          {this.state.showFetchGRNData &&

           <div>
            <div className="cc_table_header" style={{marginLeft: '1%'}}>
              
              <div className="row">

              <div style={{width: '99%', backgroundColor: '#EFEFEF', height: 75}}>

               <ButtonToolbar style={{height: 10, marginTop: 4, width: '15%'}} className="form__button-toolbar step_container">
                <Button  disabled={this.state.reason_needed} id={this.state.reason_needed ? "disable_color_step" : "enable_color_step"} className=" step_btn" onClick={this.pressCaptureReason} type="submit">
                {this.state.loadingbtn0 && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }
                <span style={{fontSize: stepFont}} className= "step_main_text">1 Capture Reason</span>  </Button>

              
                 <img 
                        src={Rectangle} 
                        alt="Rectangle" 
                        style={{ width: "25px", height: "4px", marginLeft: '6%',  marginTop: imageMargin }} 
                      />
             

              </ButtonToolbar>

               <ButtonToolbar style={{height: 10, marginTop: 4, width: '18%'}} className="form__button-toolbar step_container">
                <Button  disabled={this.state.disabledBtn0} id={this.state.disabledBtn0 ? "disable_color_step" : "enable_color_step"} className=" step_btn" onClick={this.pressStep0} type="submit">
                {this.state.loadingbtn0 && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }
                <span  style={{fontSize: stepFont}} className= "step_main_text">2 Product Verification</span> <br/>{(this.state.approved == 0) && <span className= "step_sub_text">CC Approval required before proceeding.</span>} {(this.state.approved == 1) && (!this.state.disabledBtn0) && <span className= "step_sub_text1">Click to proceed, Cannot cancel the CC post this</span>} {(this.state.approved == 2) && (!this.state.disabledBtn0) && <span className= "step_sub_text">CC Approval rejected. Please recheck the batch.</span>} </Button>


                <img 
                        src={Rectangle} 
                        alt="Rectangle" 
                        style={{ width: "25px", height: "4px", marginLeft: '6%',  marginTop: imageMargin }} 
                      />
              </ButtonToolbar>

              <ButtonToolbar  style={{height: 10, marginTop: 2, width: '16%'}} className="form__button-toolbar step_container">
                <Button  id={this.state.disabledBtn1 ? "disable_color_step" : "enable_color_step"} disabled={this.state.disabledBtn1} className="modal_ok disabledRecheck step_btn" onClick={this.pressStep1} type="submit">
                {this.state.loadingbtn1 && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }
                <span  style={{fontSize: stepFont}} className= "step_main_text">3 MATCH <br/>{!this.state.disabledBtn1 && <span className= "step_sub_text1">Click to proceed</span>}</span></Button>

                <img 
                        src={Rectangle} 
                        alt="Rectangle" 
                        style={{ width: "25px", height: "4px", marginLeft: '6%' , marginTop: imageMargin }} 
                      />
              </ButtonToolbar>

               <ButtonToolbar style={{marginTop: 4, width: '18%'}} className="form__button-toolbar step_container">
                <Button  disabled={this.state.disabledBtn2} id={this.state.disabledBtn2 ? "disable_color_step" : "enable_color_step"}className="btn-sm step_btn" onClick={this.pressStep2} type="submit">
                {this.state.loadingbtn2 && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }
                <span  style={{fontSize: stepFont}} className= "step_main_text">4 SHORT <br/>{!this.state.disabledBtn2 && <span className= "step_sub_text1">Click to process the Physical Short in the System</span>}</span></Button>

                <img 
                        src={Rectangle} 
                        alt="Rectangle" 
                        style={{ width: "25px", height: "4px", marginLeft: '3%',  marginTop: imageMargin }} 
                      />
              </ButtonToolbar>

              <ButtonToolbar style={{marginTop: 4, width: '18%'}} className="form__button-toolbar step_container">
                <Button  disabled={this.state.disabledBtn3} id={this.state.disabledBtn3 ? "disable_color_step" : "enable_color_step"} className="btn-sm step_btn" onClick={this.pressStep3} type="submit">
                {this.state.loadingbtn3 && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }
                 <span   style={{fontSize: stepFont}} className= "step_main_text">5 EXCESS <br/>{!this.state.disabledBtn3 && <span className= "step_sub_text1">Click to process the Physical Excess in the System</span>} </span></Button>

                <img 
                        src={Rectangle} 
                        alt="Rectangle" 
                        style={{ width: "25px", height: "4px", marginLeft: '3%' ,  marginTop: imageMargin}} 
                      />
              </ButtonToolbar>

              <ButtonToolbar style={{height: 10, marginTop: 4, width: '11%'}} className="form__button-toolbar step_container">
                <Button color="primary" disabled={this.state.disabledBtn4} id={this.state.disabledBtn4 ? "disable_color_step" : "enable_color_step"} className="btn-sm step_btn" onClick={this.pressStep4} type="submit">
                {this.state.loadingbtn4 && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }
                 <span  style={{fontSize: stepFont}} className= "step_main_text">6 COMPLETE <br/>{!this.state.disabledBtn4 && <span className= "step_sub_text1">ClicktocompletetheCC</span>} </span></Button>

              </ButtonToolbar>

             {/* <ButtonToolbar style={{height: 8,}}  className="form__button-toolbar col-xl-2col-sm-2 col-lg-2">
              <i onClick={this.toggle} style={{fontSize: 24, textAlign: 'right'}} class="fa fa-hand-paper-o fa-rotate-90"></i>
               
                
              </ButtonToolbar>

               <ButtonToolbar style={{height: 8,}}  className="form__button-toolbar col-xl-4 col-sm-4 col-lg-4">
               {this.state.showDisabledBtn ? 
                          (
                          
                          <Button  style={{backgroundColor: '#24d6a3', color: '#fff', margin: 0 , paddingTop: 4, paddingBottom: 4 , paddingLeft: 10, paddingRight: 10, fontWeight: 'bold', fontSize: 12}} className="modal_ok"  onClick={this.recheckData}>Recheck</Button> 
                         

                          ):(
                          
                          <Button id="change_color" style={{ backgroundColor: '#ccc',  margin: 0 , paddingTop: 4, paddingBottom: 4 , paddingLeft: 10, paddingRight: 10, fontWeight: 'bold', fontSize: 12}} className="modal_ok disabledRecheck" disabled={true}  onClick={this.recheckData}>Recheck</Button> 
                          
                        )}
               
                
              </ButtonToolbar>*/}

              </div>
              <div style={{width: '100%', marginTop: '2%'}}>
             

               <ButtonToolbar style={{height: 8, width: '94%', float: 'left'}}  className="form__button-toolbar">
               {(this.state.showDisabledBtn)  ? 
                          (
                          
                          <Button id={this.state.recheckDisable ? "change_color" : "enable_recheck"} disabled={this.state.recheckDisable}  style={{backgroundColor: '#24d6a3', color: 'black', margin: 0 , paddingTop: 4, paddingBottom: 4 , paddingLeft: 10, paddingRight: 10, fontWeight: 'bold', fontSize: 12,}} className="button_view"  onClick={this.recheckData}>Recheck</Button> 
                         

                          ):(
                          
                          <Button id="change_color" style={{ backgroundColor: '#ccc',  margin: 0 , paddingTop: 4, paddingBottom: 4 , paddingLeft: 10, paddingRight: 10, fontWeight: 'bold', fontSize: 12, display: 'none'}} className="modal_ok disabledRecheck button_view" disabled={true}  onClick={this.recheckData}>Recheck</Button> 
                          
                        )}
               
                
              </ButtonToolbar>

               <ButtonToolbar onClick={this.toggle} style={{height: 8, width: '6%', float: 'left', textAlign: 'right', marginBottom: 8}}  className="form__button-toolbar">
              {/*<i  style={{fontSize: 24, textAlign: 'right', marginBottom: 10, cursor: 'pointer'}} class="fa fa-hand-paper-o fa-rotate-90"></i>
              <span style={{cursor: 'pointer'}}> Product Wise </span>*/}
              <img
                    src={require("../../../../images/flip.png")}
                    style={{ width: "28px", height: "28px", marginTop: -15, cursor: 'pointer' }}
                  ></img>
               
                
              </ButtonToolbar>
              </div>
              </div>
            </div>
            
            <div className="table_val1">
               <div className="inbound_table">
                        <div className="table-responsive" style={{ overflowX: 'auto' }}>
                          <table className="table" id="table_styling" style={{ width: '100%', }}>
                    <thead>
                      <tr>

                       <th> #</th>
                           
                        <th onClick={() => this.sortingColumn("bin_address")}>Bin Address</th>
                        <th onClick={() => this.sortingColumn("match_status")}>Status(physical scan)</th>
                        <th onClick={() => this.sortingColumn("lb_sku_id")}>Prod Code</th>
                        <th onClick={() => this.sortingColumn("product_desc")}>Product Desc</th>
                        <th>MRP </th>
                        <th>UPC</th>
                        <th>ICLD Quantity</th>
                        <th>Loose Quantity</th>
                        <th>Total Scanned Qty</th>
                        <th>System Quantity</th>
                        <th>Deviation by value (in %)</th>
                        <th> Deviation by Qty (in %) </th>
                        <th>Bin Suggested(scanned product)</th>
                        <th onClick={() => this.sortingColumn("icld_ean")}>ICLD EAN</th>
                        <th onClick={() => this.sortingColumn("ean")}>EAN</th>
                         <th onClick={() => this.sortingColumn("ean")}>Status</th>
          {/* <th onClick={() => this.sortingColumn("user")}>Assigned User</th>
                        
                        
                        
                        
                        <th onClick={() => this.sortingColumn("zone_name")}>Zone Name</th>
                        <th>Zone Id</th>

                        <th>PKD </th>
            <th>BasePack Code</th>
                        <th>CBU Code</th>*/}

                        
                        
                        
                      
                       
                      </tr>
                    </thead>
                    <tbody>

                      {this.state.batchData.length > 0 && (

                        this.state.batchData.map((item, index) => (

                          /*<tr style={{ backgroundColor: item.color,  textAlign: 'left' }}>*/
                           <tr className="tr_border" style={{ backgroundColor: '#fff', marginBottom: '5px' }} key={index}>
                             {item.step_allowed === false &&
                            (
                              <td style={{textAlign: 'center'}}> <input  style={{ marginTop: '-5px', position: 'relative', top: '-5px' }} type="checkbox" value={item.isChecked} checked={item.isChecked} onChange={() => this.checkedSingle(index, item.product_code, item.mrp)} disabled={item.mandatory}/> </td>
                            )}
                             {item.step_allowed === 1 &&
                            (
                              <td> </td>
                            )}

                            
                             {item.step_allowed === 0 &&
                            (
                              <td> <input style={{ marginTop: '-4px', position: 'relative', top: '-4px' }} type="checkbox" value={item.isChecked} checked={item.isChecked} onChange={() => this.checkedSingle(index, item.product_code, item.mrp)} disabled={item.mandatory}/> </td>
                            )}

                            
                             {item.step_allowed === 2 &&
                            (
                              <td> </td>
                            )}

                             {item.step_allowed === 3 &&
                            (
                              <td> </td>
                            )}

                             {item.step_allowed === 4 && 
                            (
                              <td> </td>
                            )}

                             {item.step_allowed === 5 &&
                            (
                              <td> </td>
                            )}

                            <td style= {{color: '#232329'}}>  {item.bin_address} </td>
              {/*<td style= {{color: '#232329'}}> {item.user} </td>*/}
                           
                            {item.match_status === "MATCH" ? 
                            (
                              /*<td style={{color: "green", fontWeight: 'bold'}}> {item.match_status} </td>*/
                              <td> <div className="approved_div"><span className="approved_text">{item.match_status}</span></div></td>
                            ):(
                              /*<td style={{color: "#ca0707", fontWeight: 'bold'}}> {item.match_status} </td>*/
                              <td> <div className="rejected_div"><span className="rejected_text">{item.match_status}</span></div></td>
                            )}
                            <td style= {{color: '#232329'}}> {item.product_code} </td>
                            <td style= {{color: '#232329'}}> {item.product_desc} </td>
                             <td style= {{color: '#232329'}}> {item.mrp} </td>
                             <td style= {{color: '#232329'}}> {item.upc} </td>
                             <td style= {{color: '#232329'}}> {item.icld_qty} </td>
                            <td style= {{color: '#232329'}}> {item.loose_qty} </td>
                             <td style= {{color: '#232329'}}> {item.scanned_qty} </td>
                            <td style= {{color: '#232329'}}> {item.system_qty} </td>
                             <td style= {{color: '#232329'}}> {item.value_deviation} </td>
                            <td style= {{color: '#232329'}}> {item.qty_deviation} </td>
                           
                            <td style={{color: '#70bbfd' , fontWeight: 'bold'}}> {item.suggested_bin} </td>


                             {(item.match_status === "JUNK" || item.match_status === "PRODUCT MISMATCH" || item.match_status === "PRODUCT NOT FOUND" || item.match_status === "EMPTY BIN" && item.ean == "" ) ? 
                          (
                            <td style= {{color: '#232329'}}> {item.icld_ean} </td>
          
                          ):(
                            <td> </td>
                          )

                          }

                          {(item.match_status === "JUNK" || item.match_status === "PRODUCT MISMATCH" || item.match_status === "PRODUCT NOT FOUND" || item.match_status === "EMPTY BIN" && item.icld_ean == "" ) ? 
                          (
                            <td style= {{color: '#232329'}}> {item.ean} </td>
          
                          ):(
                            <td> </td>
                          )

                          }

                         
                           
                            
                           {/* <td style= {{color: '#232329'}}> {item.zone_name} </td>
                            <td style= {{color: '#232329'}}> {item.zone_id} </td>

                           
                            <td style= {{color: '#232329'}}> {item.pkd} </td>
              <td style= {{color: '#232329'}}> {item.base_pack_code} </td>
                            <td style= {{color: '#232329'}}> {item.cbu_code} </td>*/}
                            
                            

                            {/*<td>
                                    {item.approval_status == "Approval Pending" ? (
                                      <div className="pending_div1"><span className="pending_text">{item.approval_status}</span></div>
                                    ) : item.approval_status == "Approved" ? (
                                      <div style={{ display: 'flex', alignItems: 'center' }}><div className="approved_div"><span className="approved_text">{item.approval_status}</span></div></div>
                                    ) : item.approval_status == "Rejected" ? (
                                      <div style={{ display: 'flex', alignItems: 'center' }}><div className="rejected_div"><span className="rejected_text">{item.approval_status}</span></div></div>
                                    ) : (
                                      <div style={{ display: 'flex', alignItems: 'center' }}>{item.approval_status}</div>
                                    )}
                                  </td>*/}

                                <td>
                                    {item.approval_status == "Approval Pending" ? (
                                      <span style={{color: '#FBBB00'}} className="pending_text_color"><img src={YellowClock} alt="yellowClock" style={{ marginRight: "7px", width: "18px", height: "18px" }} />{item.approval_status}</span>
                                    ) : item.approval_status == "Approved" ? (
                                      <span className="approved_text"><img src={GreenTick} alt="greenTick" style={{ marginRight: "7px", width: "18px", height: "18px" }} />{item.approval_status}</span>
                                    ) : item.approval_status == "Rejected" ? (
                                      <span className="rejected_text"><img src={RedCross} alt="redCross" style={{ marginRight: "7px", width: "18px", height: "18px" }} />{item.approval_status}</span>
                                    ) : (
                                      <div style={{ display: 'flex', alignItems: 'center' }}>{item.approval_status}</div>
                                    )}
                                  </td>


                          </tr>



                        )))
                      }






                    </tbody>
                  </table>
                  </div>
                  </div>
            </div>

         
          </div>
        }


        {this.state.showFetchGRNDataTester &&

           <CardBody style={{marginTop: 20}}>
            <div className="table_header">
              
              
             <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" disabled={this.state.disabledBtn} className="btn-sm" onClick={this.beforeConfirm} type="submit">
                {this.state.loadingbtn && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }
                Confirm</Button>
              </ButtonToolbar>
            </div>
            
            <div className="table_val">

            <MDBTable scrollX={true}  striped bordered>
              <MDBTableHead columns={GRNDataTester.columns}/>
              <MDBTableHead>
               {this.state.loading && 
                <div style={{width: '2300%', textAlign: 'center', paddingTop: 22}}>
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" , fontSize: 18 }}
                      />
                  </div>
              }

              </MDBTableHead>
              <MDBTableBody rows={GRNDataTester.rows} />
            </MDBTable>
            </div>

         
          </CardBody>
        }


        </Card>

        <Modal
          isOpen={modal}
          toggle={this.toggle}
          style={{maxWidth: 1050, height: 500, padding: 0}}
        >
          <div className="modal__header" style={{backgroundColor: '#70bbfd'}}>
            <h4 className="text-modal  modal__title" style={{color: '#fff', paddingTop: 10}}>Product Wise Data</h4>
          </div>
          <div className="modal__body" style={{marginTop: 10, padding: 16}}>
            <div style={{width: '100%'}}>
             
            </div>

            <table
                className="table table-bordered table-hover"
                id="cc_confirm_table"
              >

              <thead style={{textAlign: 'left'}}> 
                  <tr>
                    <th>Product code</th>
                    <th>Product Name</th>
                    <th>Mrp</th>
                   
                    <th>System Qty</th>
                    <th>Physical Qty</th>
                    <th>Deviation val (in %)</th>
                    <th>Deviation qty (in %)</th>
                     <th>Status</th>

                    
                  </tr>
                </thead>
               <tbody>

            
                {this.state.productData.length > 0 && (

                        this.state.productData.map((item, index) => (

                          <tr style={{ backgroundColor: item.color,  textAlign: 'center' }}>
                            
                              <td> {item.product_code} </td>
                              <td> {item.product_desc} </td>
                              <td> {item.mrp} </td>
                              
                              <td> {item.system_qty} </td>
                              <td> {item.scanned_qty} </td>
                              <td> {item.value_deviation} </td>
                              <td> {item.qty_deviation}</td>
                              <td> {item.match_status} </td>



                    
                            </tr>
                            )))}

                     
                     

           
           
          </tbody>
              </table>
             


              <ButtonToolbar className="modal__footer">
                <button className="modal_cancel"  onClick={this.toggle}>Cancel</button>
              </ButtonToolbar>
            </div>
          
          </Modal>




          <Modal
          isOpen={modalbeforeConfirm}
          toggle={this.beforeConfirm}
          style={{maxWidth: 700, height: 500, padding: 0}}
        >
          <div className="modal__header" style={{backgroundColor: '#70bbfd'}}>
            <h4 className="text-modal  modal__title" style={{color: '#fff', paddingTop: 10}}>Assign Users</h4>
          </div>
          <div className="modal__body" style={{padding: 14}}>
             <Table responsive className="table--bordered" style={{marginBottom: 75}}>
                    <thead>
                      <tr>
                        <th>Zone No. </th>
                        <th>Zone Name</th>
                        <th> Bin Count </th>
                        <th>User</th>
                        
                        
                      </tr>
                    </thead>

                    <tbody>

                    
                        <tr>
                          <td>11</td>
                          <td>Ac 6 inch </td>
                          <td>
                             <Select
                                isMulti
                                onChange={selectedOptions => this.onChangeVal1(selectedOptions)}
                                options={options2}
                                clearable={this.state.clearData}
                                closeOnSelect={true}
                                removeSelected={this.state.removeSelectedDate}
                                className="react-select"
                                classNamePrefix="react-select"
                              />
                          </td>
                         
                                           
                          
                        </tr>

                     


                    </tbody>
                   
                  </Table>

                  <ButtonToolbar className="modal__footer">
                    <button  className="modal_cancel"  onClick={this.CancelBeforeModal}>Cancel</button>
                    <Button disabled={this.state.disabledBtnConfirm} style={{backgroundColor: '#24d6a3', color: '#fff', marginLeft: 12}} className="modal_ok"  onClick={this.ConfirmPutAway}>
                    {this.state.loadingprintbtn && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }  
                    Confirm</Button>
                  </ButtonToolbar>
          </div>
          
        </Modal>



        <Modal
          isOpen={EditModal}
          toggle={this.EditToggle}
          style={{maxWidth: 500, height: 500, padding: 0}}
          >
          <div className="modal__header" style={{backgroundColor: '#70bbfd'}}>
            <h4 className="text-modal  modal__title" style={{color: '#fff', paddingTop: 10}}>Edit Entry</h4>
          </div>
          <div className="modal__body" style={{padding: 12}}>
            <div style={{width: '100%'}}>
              <div style={{width: '50%', float:'left',textAlign: 'left'}}>
                <span style={{fontSize: 15}}><span style={{fontWeight: 'bold'}}> LB SKU ID: </span> <span> {this.state.lbskuid_val} </span> </span> 
              </div>

              <div style={{width: '50%', float:'left',textAlign: 'right'}}>
                <span style={{fontSize: 15}}><span style={{fontWeight: 'bold'}}> BIN ID: </span> <span> {this.state.binId} </span> </span> 
              </div>

              <div style={{width: '50%', float:'left',textAlign: 'left'}}>
                <span style={{fontSize: 15}}><span style={{fontWeight: 'bold'}}> PKD: </span> <span> {this.state.pkd_val} </span> </span> 
              </div>

              <div style={{width: '50%', float:'left',textAlign: 'right'}}>
                <span style={{fontSize: 15}}><span style={{fontWeight: 'bold'}}> MRP: </span> <span> {this.state.mrp_val} </span> </span> 
              </div>

            </div>
             <Table responsive className="table--bordered" style={{marginBottom: 10, marginTop: 15}}>
                    <tbody>
                      
                    
                        <tr>
                          <td>Pick Qty ICLD</td>
                          <td><input type ="text" defaultValue={this.state.icldQty} onChange={this.changeICLDQty} style={{padding: 4, borderRadius: 2}} />
                          <br/>
                          { this.state.showICLDError && (
                            <span style={{fontSize: 11, color: 'red'}}> Pick Icld quantity exceeds actual pick quantity </span>

                          )}
                           </td>
                                           
                          
                        </tr>

                        <tr>
                          <td>Pick Qty LOOSE</td>
                          <td><input type ="text" defaultValue={this.state.looseQty} onChange={this.changeLooseQty} style={{padding: 4, borderRadius: 2}} />
                          <br/>
                            { this.state.showLooseError && (
                              <span style={{fontSize: 11, color: 'red'}}> Pick Loose quantity exceeds actual quantity </span>

                            )}
                           </td>
                                           
                          
                        </tr>

                        <tr>
                          <td>Pick Qty Tester</td>
                          <td><input type ="text" defaultValue={this.state.testerQty} onChange={this.changeTesterQty} style={{padding: 4, borderRadius: 2}} />
                          <br/>
                            { this.state.showTesterError && (
                              <span style={{fontSize: 11, color: 'red'}}> Pick Tester quantity exceeds actual pick quantity </span>

                            )}
                           </td>
                                           
                          
                        </tr>

                        

                    
                     


                    </tbody>
                  </Table>

                  <ButtonToolbar className="modal__footer">
                    <button className="modal_cancel"  onClick={this.togglePressCancel}>Cancel</button>
                    <Button style={{backgroundColor: '#24d6a3', color: '#fff', marginLeft: 12, backgroundColor: '#3ea3fc'}} className="modal_ok"  onClick={this.processUpdateData}>
                    {this.state.loadingupdatebtn && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }  
                    Update</Button>
                  </ButtonToolbar>
          </div>
          
        </Modal>





          <Modal
            isOpen={Errormodal}
            toggle={this.Errortoggle}
            >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.Errortoggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4>{this.state.ErrorMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.Errortoggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>

        <Modal
            isOpen={Successmodal}
            toggle={this.Successtoggle}
            >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.Successtoggle} />
            

           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-checkmark-circle modal__title-icon" style={{color: 'green'}} />
            <h4>Successfully Updated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.CancelSuccessToggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>

        <Modal
            isOpen={Confirmmodal}
            toggle={this.Confirmtoggle}
            >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.Confirmtoggle} />
            

           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-checkmark-circle modal__title-icon" style={{color: 'green'}} />
            <h4>Successfully Updated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.CancelConfirmToggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>

        <Modal
            isOpen={ErrorMessagemodal}
            toggle={this.ErrorMessagetoggle}
            >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.Confirmtoggle} />
            

           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4>{this.state.errorMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button className="modal_cancel"  onClick={this.CancelErrorMessageToggle}>Cancel</button>
          </ButtonToolbar>
        </Modal>



        <Modal
          isOpen={modalAssignUserCycleCount}
          toggle={this.toggleAssignUserCycleCount}
          style={{maxWidth: 700, height: 500, padding: 0}}
        >
          <div className="modal__header" style={{backgroundColor: '#70bbfd'}}>
            <h4 className="text-modal  modal__title" style={{color: '#fff', paddingTop: 10}}>Assign Users</h4>
          </div>
          <div className="modal__body" style={{padding: 14}}>
             <Table responsive className="table--bordered" style={{marginBottom: 75}}>
                    <thead>
                      <tr>
                        <th>Zone Id</th>
                        <th>Zone Name</th>
                        <th> Bin Count </th>
                        <th>Users</th>

                        
                      </tr>
                    </thead>
                    <tbody>
                      {
                        Object.keys(uniqueZoneData1).length>0  && (
                      
                        _.map(uniqueZoneData1, (item, key) => (
                    
                        <tr key={key}>
                          <td>{item.zoneId}</td>
                          <td>{item.zoneName} </td>
                          <td>{item.items.length} </td>
                          <td>

                          <div className="form__form-group">
                            <div className="form__form-group-field">
                              <Select
                                isMulti
                                name={`multiSelect_${item.zoneId}`}
                                value={selectedUser[item.zoneId]}
                                onChange={selectedOptions => this.onChangeVal(selectedOptions, item.zoneId, item.items)}
                                options={optionsUser}
                                clearable={true}
                                closeOnSelect={true}
                                removeSelected={true}
                                className="react-select"
                                classNamePrefix="react-select"
                              />
                            </div>
                          </div>

                          </td>
                                           
                          
                        </tr>

                        )))}

                    
                     


                    </tbody>
                  </Table>

                  <ButtonToolbar className="modal__footer">
                    <button style={{ marginRight: 8}} className="modal_cancel"  onClick={this.toggleAssignUserCycleCount}>Cancel</button>
                    <Button style={{backgroundColor: '#24d6a3', color: '#fff', marginLeft: 12}} className="modal_ok"  onClick={this.processData1}>
                    {this.state.loadingprintbtn && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }
                    Confirm</Button>
                  </ButtonToolbar>
          </div>
          
        </Modal>


         <Modal
            isOpen={StepSuccessModal}
            toggle={this.StepSuccessToggle}
            >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.StepSuccessToggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-checkmark-circle modal__title-icon" style={{color: 'green'}} />
            <h4>{this.state.StepSuccessMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.CancelStepSuccessToggel}>Ok</Button>
          </ButtonToolbar>
        </Modal>
    
    <Modal
            isOpen={this.state.StepCompleteModal}
            toggle={this.StepCompleteToggle}
            >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.StepCompleteToggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-checkmark-circle modal__title-icon" style={{color: 'green'}} />
            <h4>Activity for this Batch is Completed</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.CancelCompleteToggel}>Ok</Button>
          </ButtonToolbar>
        </Modal>


      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));
